import { useState } from 'react';

type FormErrors<T> = {
    [K in keyof T]?: string;
}

const useForm = <T>(initialValues: T) => {

    const [values, setValues] = useState<T>(initialValues);
    const [errors, setErrors] = useState<FormErrors<T>>({});

    const handleChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
        const { name, value } = event.target;
        setValues(prev => ({
            ...prev,
            [name]: value,
        }));
    };

    const setFormValue = <K extends keyof T>(key: K, value: T[K]) => {
        setValues(prev => ({
            ...prev,
            [key]: value,
        }));
    };

    const setFormValues = (valuesToUpdate: Partial<T>) => {
        setValues(prev => ({
            ...prev,
            ...valuesToUpdate,
        }));
    };

    const handleSubmit = (event: React.FormEvent<HTMLFormElement>, callback: () => void) => {
        event.preventDefault();
        if (callback) {
            callback();
        }
    };

    const validate = (name: keyof T, validationFunc: (value: any) => string | null) => {
        if (!validationFunc) return;
        const error = validationFunc(values[name]);
        setErrors(prev => ({
            ...prev,
            [name]: error,
        }));
    };

    return {
        values,
        errors,
        handleChange,
        setFormValue,
        setFormValues,
        handleSubmit,
        validate,
    };
}

export default useForm;